import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { View } from 'react-native';

import { Button  } from 'app/src/elements/buttons';
import Input from 'app/src/elements/inputs';
import { Text } from 'app/src/styles';

import { GET_RESET_LINKS } from './queries';

const ResetLinks = () => {
  const [resetLinks, setResetLinks] = useState();

  const [getResetLinks] = useMutation(GET_RESET_LINKS, {
    onCompleted: data => {
      setResetLinks(data.getResetLinks.resetLinks);
    }
  });

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { email: '' }
  });

  const onSubmit = variables => {
    getResetLinks({ variables });
  };

  return (
    <View style={{ gap: 10 }}>
      <Text>
        Use this form to generate a link you can send to a buyer user or seller
        user to set or reset their password.
      </Text>

      <Input.Text
        label="Email:"
        name="email"
        control={control}
        errors={errors}
      />

      {'undefined' !== typeof resetLinks && (
        0 === resetLinks.length ? (
          <Text>No users found with this email</Text>
        ) : (
          <View>
            {resetLinks.map(resetLink => (
              <Text key={resetLinks.url}>
                {resetLink.userType} - {resetLink.fullName}{': '}
                {resetLink.url}
              </Text>
            ))}
          </View>
        )
      )}

      <Button label="Get Links" onPress={handleSubmit(onSubmit)} />
    </View>
  );
};

export default ResetLinks;
